import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

// Which control dismissed the panel. A submit with a term or a result click closes the panel too,
// but those exits are already recorded as `search` / `product_card` / `article_card` and do not
// fire this. `search_box` is the submit with NOTHING typed - Enter or the icon on an empty box -
// which closes the panel and would otherwise leave the opening with no exit at all.
export type SearchClosePlacement =
  | 'backdrop'
  | 'close_button'
  | 'escape_key'
  | 'search_box';

export type SearchCloseTargetProperties = {
  placement: SearchClosePlacement;
  result_count?: number;
  search_term?: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: SearchClosePlacement;
  resultCount?: number;
  searchTerm?: string;
};

class SearchCloseInteractionEvent extends InteractionEvent<
  EventData,
  SearchCloseTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'search_close';
  }

  protected getTargetProperties(): SearchCloseTargetProperties {
    const searchTerm = this.data.searchTerm || undefined;

    return {
      placement: this.data.placement,
      // The count describes the term in the box; with no term there is nothing it describes.
      result_count: searchTerm ? this.data.resultCount : undefined,
      search_term: searchTerm
    };
  }
}

export default SearchCloseInteractionEvent;
